module.exports = __webpack_public_path__ + "img/slogan_en.91a92500.png";